import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FACTORY_MANAGE_VACATIONS_REPOSITORY,
  FactoryManageVacationsRepository
} from '@app/domain/repositories/manage-vacations/factory/factory-manage-vacations.repository.contract';
import { FactoryManageVacationsUseCases } from '@app/domain/use-cases/manage-vacations/factory/factory-manage-vacations.use-cases.contract';
import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { AnualCalendarMonth } from '@app/entities/models/lababs/lababs-vacations.model';
import {
  FactoryCompensation,
  FactoryManageVacationsProposals
} from '@app/entities/models/manage-vacations/factory-manage-vacations.model';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import { MotFactoryProposal } from '@app/entities/models/manage-vacations/mot-manage-vacations.model';

import { TUserTypeCalendarProposal } from '@/types/manage-vacations.type';

@Injectable({
  providedIn: 'root'
})
export class FactoryManageVacationsUseCasesImpl implements FactoryManageVacationsUseCases {
  #factoryManageVacationsRepository: FactoryManageVacationsRepository = inject(FACTORY_MANAGE_VACATIONS_REPOSITORY);

  getProposals(): Observable<FactoryManageVacationsProposals> {
    return this.#factoryManageVacationsRepository.getProposals();
  }
  getVacationsCriteria(): Observable<ManageVacationsCriteria> {
    return this.#factoryManageVacationsRepository.getVacationsCriteria();
  }
  getVacationsSeason(): Observable<VacationsSeason> {
    return this.#factoryManageVacationsRepository.getVacationsSeason();
  }

  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>> {
    return this.#factoryManageVacationsRepository.getSeasonCalendar(season);
  }

  createProposal(
    proposals: FactoryManageVacationsProposals,
    storedProposals: MotFactoryProposal[],
    isSummerSeason: boolean
  ): Observable<FactoryManageVacationsProposals> {
    return this.#factoryManageVacationsRepository.createProposal(proposals, storedProposals, isSummerSeason);
  }

  updateObservations(observations: string): Observable<EmployeeObservations> {
    return this.#factoryManageVacationsRepository.updateObservations(observations);
  }

  getCompensation(): Observable<FactoryCompensation> {
    return this.#factoryManageVacationsRepository.getCompensations();
  }

  createCompensation(compensations: FactoryCompensation): Observable<FactoryCompensation> {
    return this.#factoryManageVacationsRepository.createCompensation(compensations);
  }

  getCalendar(): Observable<AnualCalendarMonth[]> {
    return this.#factoryManageVacationsRepository.getCalendar();
  }
}
